import { keepPreviousData } from '@tanstack/react-query';

import { Environment } from '@playq/octopus-common';
import { ClusterizationReport, ClusterizationRunId } from '@playq/services-beetle';
import { GenericFailure, OffsetLimit } from '@playq/services-shared';

import { services2 } from '/api';
import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';

const reportKeys: unknown[] = ['report', 'query'];
export const useQueryReport = (
  runId: ClusterizationRunId,
  iterator: OffsetLimit,
  env: Environment,
  minSize = 2,
  maxSize = 20,
  limitClusterDocuments = 20,
  options?: IUseQueryOptionsExtended<ClusterizationReport | undefined, GenericFailure | Error>
) => {
  const {
    mutate: _mutate,
    refetch: _refetch,
    ...res
  } = useEitherQuery(
    reportKeys.concat(runId, env, minSize, iterator, maxSize, limitClusterDocuments),
    () => {
      return services2.audienceRequestsClusterizationService.queryReport(
        runId,
        minSize,
        maxSize,
        limitClusterDocuments,
        iterator,
        env
      );
    },
    {
      placeholderData: keepPreviousData,
      ...options,
    }
  );

  return { ...res };
};
